// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const EscapeRegExp = (str: string) => {
  if (str)
    // eslint-disable-next-line no-useless-escape
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
  return ''
}

export default EscapeRegExp
